// Values are loaded from assets/config/config.json at startup, before the app is
// bootstrapped, so one build can be deployed to any environment by swapping that
// file. The defaults below are only used if the file cannot be read.
export interface AppConfig {
  production: boolean;
  apiBaseUrl: string;
  entra: {
    clientId: string;
    tenantId: string;
    apiScope: string;
  };
  azureMapsSubscriptionKey: string;
  functionKey: string;
}

export const environment: AppConfig = {
  production: true,
  apiBaseUrl: '/api',
  entra: {
    clientId: '',
    tenantId: '',
    apiScope: ''
  },
  azureMapsSubscriptionKey: '',
  functionKey: ''
};

export function applyRuntimeConfig(config: Partial<AppConfig> | null | undefined): void {
  if (!config) {
    return;
  }

  if (typeof config.production === 'boolean') {
    environment.production = config.production;
  }
  if (config.apiBaseUrl) {
    environment.apiBaseUrl = config.apiBaseUrl;
  }
  if (config.azureMapsSubscriptionKey) {
    environment.azureMapsSubscriptionKey = config.azureMapsSubscriptionKey;
  }
  if (config.functionKey) {
    environment.functionKey = config.functionKey;
  }
  if (config.entra) {
    environment.entra.clientId = config.entra.clientId || environment.entra.clientId;
    environment.entra.tenantId = config.entra.tenantId || environment.entra.tenantId;
    environment.entra.apiScope = config.entra.apiScope || environment.entra.apiScope;
  }
}
